import React from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  //CardTitle,
  Modal,
  withGrid,
} from '../../../Components'

const Grid = withGrid(CardContent)
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`

const StyledModal = styled(Modal)<any>`
  top: 40px;
`
const Div = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  justify-content: center;
`

const P = styled.p`
  font-weight: 600;
  color: #000;
  font-size: x-large;
  display: flex;
  justify-content: center;
`

const ButtonModal = styled.button`
  margin: 10px;
  background-color: #2a36e0;
  font-weight: 400;
  font-size: larger;
  color: white;
  border-width: 0.1rem;
  border-color: gray;
  cursor: pointer;
  border-radius: 3px;
  &:hover {
            background-color: #606eba;
        }
`

interface ModalEscolhaPerfilProps {
  setModal: (isOpen: boolean) => void
  isModalOpen: boolean
  roles: string[]
}

export function ModalEscolhaPerfil({ setModal, isModalOpen, roles }: ModalEscolhaPerfilProps) {
  const history = useHistory()

  const handlePage = (path: string): void => {
    setModal(false)
    history.push(path)
  }

  return (
    <StyledModal isVisible={isModalOpen} outterClick={() => setModal(false)} size={'small'}>
      <Card>
        <P>Perfis Disponíveis</P>

        <CardContentGrid>
          <Div>
            {roles.map(role=>(
              <ButtonModal key={role} onClick={() => handlePage(`/${role}/`)}>{role.toUpperCase()}</ButtonModal>
            ))}
          </Div>
        </CardContentGrid>

        <CardActions>
          <Button onClick={() => setModal(false)}>Cancelar</Button>
        </CardActions>
      </Card>
    </StyledModal>
  )
}
